import { render, staticRenderFns } from "./tmTicks.vue?vue&type=template&id=7a15f4b3&"
import script from "./tmTicks.vue?vue&type=script&lang=js&"
export * from "./tmTicks.vue?vue&type=script&lang=js&"
import style0 from "./tmTicks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports